import React, { useEffect } from "react";

import useTranslations from "containers/hooks/useLanguageHook";
import { useContentSize } from "containers/hooks/useWindowSize";
import ContactNetwork from "containers/Visuals/ContactNetwork";
import { useAppDispatch, useAppSelector } from "index";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import { ApplicationState } from "@store/index";
import { Grid } from "@mui/material";
import { calculateGridItemSize } from "@utils/format";
import { GridSize } from "@mui/material/Grid";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { getProvider } from "../../fileParsing/definitions";
import { switchActive } from "@store/data/actions";
const NetworkImage = new URL("../../../public/contactnetwork.png", import.meta.url).href;

function ContactNetworkPage() {
  const { width, height } = useContentSize();
  const { t } = useTranslations();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.providers, FilterType.messageCount]));
    dispatch(setCurrentVisualization(VisTypes.ContactGraph));
  }, [dispatch]);

  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  const activeExports = providerItems.filter((d) => d.active);

  return (
    <VisPageWrapper
      title={t.Vis.ContactGraph}
      help={{
        title: t.LandingPage.NetworkGraphTitle,
        description: t.LandingPage.NetworkGraphText,
        image: NetworkImage,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1}>
          {activeExports.map((d, i, list) => (
            <Grid item xs={calculateGridItemSize(list.length) as GridSize} key={d.id}>
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={d.providerId === "wrangled" ? t.DataPage.UnknownProvider : getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              <ContactNetwork
                exportIds={[d.id]}
                size={{
                  width,
                  height: height / 2 - 32,
                }}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ContactNetwork
          size={{
            width,
            height,
          }}
        />
      )}
    </VisPageWrapper>
  );
}

export { ContactNetworkPage };
